(function() {
    'use strict';
    var MatchPopCtrl = function($scope, $compile, $uibModalInstance, $window, ajaxCall, passedModel) {
        console.log("Inside MatchPopCtrl");
        $scope.matchPopModel = {};
        $scope.matchPopModel.errorMessageVal = '';
        $scope.matchPopModel.errorMessage = false;
        $scope.matchPopModel.disableBtn = false;
        $scope.ngModel = passedModel;


        $scope.ajaxCallList = function(ajaxUrl, data, closePop) {

            $scope.matchPopModel.disableBtn = true;
            ajaxCall.getData(ajaxUrl, data).then(function(result) {
                $scope.matchPopModel.disableBtn = false;
                if(result.data.invalidBankDetails == true){
                  $scope.matchPopModel.showInvalidBankDetailsMsg = true;
                }
                else if(result.data.success == true){
                    $scope.matchPopModel.showSuccessMsg = true;
                    $window.location.reload();
                }
                else {
                    updateErrorScope();
                }

            }, function(result) {
                $scope.matchPopModel.disableBtn = false;
                updateErrorScope();
            });
        }

        function updateErrorScope(){
            var errorMsg = 'Error';
            $scope.matchPopModel.errorMessage = true;
            $scope.matchPopModel.errorMessageVal = errorMsg;
        }

        $scope.dataCollSend = function($event) {
            $event.preventDefault();
            $scope.matchPopModel.showSuccessMsg = false;
            $scope.matchPopModel.showBankDetailsNotUpdatedMsg = false;
          $scope.matchPopModel.showInvalidBankDetailsMsg = false;
            var isValid = this.dataForm.$valid;
            if (isValid) {
                $scope.matchPopModel.disableBtn = true;
                var data = $scope.matchPopModel;
                var ajaxUrl = WEBAPP_PATH + "/dataCollection/saveUploadedValues";
                $scope.ajaxCallList(ajaxUrl, data, closePop);
            }
        }

        $scope.closePop = function($event) {
            $uibModalInstance.close($scope.ngModel);
        }
        $scope.cancel = function() {
            $uibModalInstance.close($scope.ngModel);
        };
    }
    MatchPopCtrl.$inject = ['$scope', '$compile', '$uibModalInstance', '$window', 'ajaxCall', 'params'];
    angular.module('app').controller('MatchPopCtrl', MatchPopCtrl);
}());
